import { Box, Button, ButtonGroup, Card, CardContent, CardHeader, createMuiTheme, Grid, IconButton, MuiThemeProvider, Paper, TextField, Tooltip } from '@material-ui/core'
import AddIcon from "@material-ui/icons/Add"
import { makeStyles } from '@material-ui/styles'
import MUIDataTable from 'mui-datatables'
import React, { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { HeaderBlock } from '../../components/header-block/HeaderBlock'
import { Loading } from '../../components/loading/Loading'
import PageContainer from '../../components/page-container/PageContainer'
import { DeleteModal } from '../../containers/delete-modal/DeleteModal'
import GenericPickerModal from '../../containers/generic-picker-modal/GenericPickerModal'
import { clearUsers, getUsers, GET_USER_SIZE, getUsersById } from '../../state/actions/UserActions'
import { deleteUserRole, getUserRole, getUserRoles, getUsersForRole, setUsersForRole, upsertUserRole } from '../../state/actions/UserRoleActions'

const useStyles = makeStyles({
    contentWrapper: {
        margin: "16px"
    },
    icon: {
        height: "1em",
        width: "1em"
    }
})

function ViewUserRolesPage(props) {

    const userRole = useSelector(state => state.UserRoleReducer.currentUserRole)
    const users = useSelector(state => state.UserRoleReducer.currentUsers)
    const allUsers = useSelector(state => state.UserReducer.users)
    const continuationToken = useSelector(state => state.UserReducer.continuationToken)
    const assignedUsers = useSelector(state => state.UserReducer.assignedUsers)

    const [t, i18n] = useTranslation()
    const dispatch = useDispatch()
    const classes = useStyles()

    const [loading, setLoading] = useState(false)
    const [loadingUsers, setLoadingUsers] = useState(false)
    const [loadingAllUsers, setLoadingAllUsers] = useState(false)
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
    const [isEditing, setIsEditing] = useState(false)
    const [deleteUsersDialogOpen, setDeleteUsersDialogOpen] = useState(false)
    const [addUsersDialogOpen, setAddUsersDialogOpen] = useState(false)
    const [usersToDelete, setUsersToDelete] = useState([])
    const [editedUserRole, setEditedUserRole] = useState(userRole)

    const [fetchUsers, setFetchUsers] = useState(true)
    const [fetchUserRole, setFetchUserRole] = useState(false)
    const [fetchRoles, setFetchRoles] = useState(true)
    const [fetchAllUsers, setFetchAllUsers] = useState(true)

    const [fetchAssignedUsers, setFetchAssignedUsers] = useState(false)

    const [hasNewData, setHasNewData] = useState(true)
    const [firstUserFetch, setFirstUserFetch] = useState(true)
    const [lastSearch, setLastSearch] = useState("")

    useEffect(() => {
        if (fetchRoles) {
            setLoading(true)
            dispatch(getUserRoles(() => {
                setFetchUserRole(true)
                setLoading(false)
                setFetchRoles(false)
            }))
        }
    }, [fetchRoles])

    useEffect(() => {
        if (addUsersDialogOpen == false) {
            return () => {
                dispatch(clearUsers(() => {}))
            }
        }
    }, [addUsersDialogOpen])

    useEffect(() => {
        setEditedUserRole(userRole)
    }, [userRole])

    useEffect(() => {
        if (fetchUserRole) {
            const roleId = props.match.params.userRoleId
            setLoading(true)
            dispatch(getUserRole(roleId, () => {
                setFetchUserRole(false)
                setFetchUsers(true)
                setLoading(false)
            }))
        }
    }, [fetchUserRole])

    useEffect(() => {
        if (fetchUsers) {
            const roleId = props.match.params.userRoleId
            setLoadingUsers(true)
            dispatch(getUsersForRole(roleId, () => {
                setLoadingUsers(false)
                setFetchUsers(false)
                setFetchAssignedUsers(true)
            }))
        }
    }, [fetchUsers])

    useEffect(() => {
        const userList = Object.values(users || {}).map(user => user.id)

        if (fetchAssignedUsers === true && userList.length > 0) {
            setLoadingUsers(true)

            dispatch(getUsersById(userList, () => {
                setLoadingUsers(false)
                setFetchAssignedUsers(false)
            }))
        }

    }, [fetchAssignedUsers])

    useEffect(() => {
        const searchData = continuationToken?.search != null
        const baseData = continuationToken?.base != null

        setHasNewData(searchData || baseData)
        if (!searchData) {
            setLastSearch("")
        }
    }, [continuationToken])

    function handleDeletUseRole() {
        setDeleteDialogOpen(false)
        dispatch(deleteUserRole(userRole.id, () => {
            props.history.push("/user-roles")
        }))
    }

    function handleAddUsersToRole(incomingUsers) {

        const updatedUsers = incomingUsers

        dispatch(setUsersForRole(userRole.id, updatedUsers, () => {
            setAddUsersDialogOpen(false)
            setFetchUsers(true)
        }))
    }

    function handleDeleteUsersFromRole() {
        const updatedUsers = Object.values(users).map(item => item.id).filter(item => !usersToDelete.includes(item))

        dispatch(setUsersForRole(userRole.id, updatedUsers, () => {
            setDeleteUsersDialogOpen(false)
            setFetchUsers(true)
        }))
    }

    function handleIsEditingChange() {
        if (isEditing) {
            dispatch(upsertUserRole(editedUserRole.displayName, editedUserRole.id, () => {
                setFetchRoles(true)
            }))
        }
        setIsEditing(!isEditing)
    }

    function handleFieldChange(value, field) {
        const editiedRole = Object.assign({}, editedUserRole)
        editiedRole[field] = value
        setEditedUserRole(editiedRole)
    }

    function renderContent() {

        const options = {
            elevation: 0,
            filter: true,
            responsive: "stacked",
            rowsPerPage: 10,
            rowsPerPageOptions: [10, 25, 50],
            viewColumns: false,
            filterType: "checkbox",
            print: false,
            download: true,
            selectableRows: isEditing ? "multiple" : "none",
            rowHover: true,
            downloadOptions: {
                filename: "RoleUsers.csv",
                separator: ",",
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },
            onRowClick: (rowData, rowMeta) => {
                const user = Object.values(users)[rowMeta.rowIndex]
                props.history.push(`/users${user != null ? `/${user.id}` : ""}`)
            },
            onRowsDelete: (rowsDeleted, data) => {

                var toDelete = Object.values(rowsDeleted.data).map(item => {
                    const userList = Object.values(users || {})
                    if (userList != null) {
                        const user = userList[item.dataIndex] != null ? userList[item.dataIndex].id : {}
                        return user
                    }
                    return {}
                })

                if (toDelete == null) {
                    toDelete = []
                }

                setUsersToDelete(toDelete)
                setDeleteUsersDialogOpen(true)
                return false
            },
            customToolbar: () => {
                return (
                    <Fragment>
                        {isEditing ?
                            <Tooltip title={t("user-role.assign-role")}>
                                <IconButton onClick={() => setAddUsersDialogOpen(true)}>
                                    <AddIcon />
                                </IconButton>
                            </Tooltip> :
                            null
                        }
                    </Fragment>
                );
            },
            textLabels: {
                body: {
                    noMatch: t('data-table.sorry-no-matching-records-found'),
                    toolTip: t('data-table.sort'),
                    columnHeaderTooltip: column => t('data-table.sort-for-usd-column-label', {label: column.label})
                },
                pagination: {
                    next: t('data-table.next-page'),
                    previous: t('data-table.previous-page'),
                    rowsPerPage: t('data-table.rows-per-page'),
                    displayRows: t('data-table.of')
                },
                toolbar: {
                    search: t('data-table.search'),
                    downloadCsv: t('csv.download'),
                    print: t('data-table.print'),
                    viewColumns: t('data-table.view-columns'),
                    filterTable: t('data-table.filter-table')
                },
                filter: {
                    all: t('data-table.all'),
                    title: t('data-table.filters'),
                    reset: t('data-table.reset'),
                },
                viewColumns: {
                    title: t('data-table.show-columns'),
                    titleAria: t('data-table.show-hide-table-columns'),
                },
                selectedRows: {
                    text: t('data-table.rows-deleted'),
                    delete: t('common.delete'),
                    deleteAria: t('data-table.delete-selected-rows')
                }
            }
        }

        const columns = [
            {
                name: "displayName",
                label: t("common.name"),
                options: {
                    // filter: true,
                    sort: true,
                }
            },
            {
                name: "email",
                label: t("common.email"),
                options: {
                    // filter: true,
                    sort: true,
                }
            }
        ]

        const userRoleFields = [
            {
                name: "id",
                label: t("common.id")
            },
            {
                name: "displayName",
                label: t("common.name")
            }
        ]

        const getMuiTheme = () => createMuiTheme({
            overrides: {
                MuiTableCell: {
                    body: {
                        color: "#4C73FF",
                        fontWeight: 400,
                        cursor: "pointer"
                    }
                }
            }
        })

        return (
            <Box className={classes.contentWrapper}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Card>
                            <CardHeader title={t("common.data")} />
                            <CardContent>
                                <Grid container spacing={2}>
                                    {Object.values(userRoleFields).map(value => {
                                        return (
                                            <Grid item xs={12}>
                                                <TextField
                                                    disabled={!isEditing || value.name == "id"}
                                                    fullWidth
                                                    label={value.label}
                                                    value={editedUserRole[value.name]}
                                                    onChange={(data) => handleFieldChange(data.target.value, value.name)}
                                                    variant="outlined"
                                                />
                                            </Grid>
                                        )
                                    })}
                                </Grid>

                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={6}>
                        <MuiThemeProvider theme={Object.values(users || {}).length > 0 ? getMuiTheme() : null}>
                            <Paper>
                                {loadingUsers ?
                                    <Loading /> :
                                    <MUIDataTable

                                        title={t("user.users")}
                                        data={Object.values(users || {})}
                                        columns={columns}
                                        options={options}
                                    />}
                            </Paper>
                        </MuiThemeProvider>
                    </Grid>
                </Grid>

            </Box>
        )
    }

    function deleteDialog() {
        return (
            <DeleteModal
                data={[{ id: userRole.id, Name: userRole.displayName }]}
                handleCancel={() => setDeleteDialogOpen(false)}
                handleDone={() => handleDeletUseRole()}
                open={deleteDialogOpen}
            />
        )
    }

    function deleteUsersDialog() {

        const deleteList = usersToDelete.map(item => {
            const user = users[item]
            if (user != null) {
                return { id: user.id, Name: user.displayName }
            }
            return {}
        })

        return (
            <DeleteModal
                data={deleteList || []}
                handleCancel={() => setDeleteUsersDialogOpen(false)}
                handleDone={() => handleDeleteUsersFromRole()}
                open={deleteUsersDialogOpen}
            />
        )
    }

    function getNextPage(value = "") {
        var searchValue = value
        if (value == "" && lastSearch != "" && continuationToken?.search != null) {
            searchValue = lastSearch
        }

        if (value != "") {
            setLastSearch(value)
        }

        let promiseResolver

        dispatch(getUsers(() => {
            setFirstUserFetch(false)
            setLoadingAllUsers(false)
            promiseResolver()

        }, GET_USER_SIZE.LARGE, searchValue != "" ? continuationToken?.search : continuationToken?.base, searchValue, searchValue == ""))

        return new Promise((resolve) => {
            promiseResolver = resolve
            setLoadingAllUsers(true)
        })
    }

    function handleAddUsersToRoleCancel() {
        setAddUsersDialogOpen(false)
    }

    function addUsersToRoleDialog() {
        return (
            <GenericPickerModal
                title={t("user.add-users")}
                searchTitle={t("user.user")}
                idField="id"
                valueField="name"
                open={addUsersDialogOpen}
                data={Object.values(allUsers)}
                getAllData={getNextPage}
                handleCancel={handleAddUsersToRoleCancel}
                handleDone={handleAddUsersToRole}
                selected={Object.values(users).map(item => item.id)}
                currentSelection={Object.values(users).map(item => item.id)}

                infiniteLoading
                hasNextPage={hasNewData || firstUserFetch}
                isNextPageLoading={loadingAllUsers}
                loadNextPage={getNextPage}
            />
        )
    }

    function rightRender() {
        return (
            <Grid container spacing={2} alignItems="center" justify="flex-end">
                <Grid item>
                    <ButtonGroup>
                        <Button
                            disabled={!isEditing}
                            color="primary"
                            variant="outlined"
                            onClick={() => setDeleteDialogOpen(true)}
                        >
                            {t("common.delete")}
                        </Button>
                        <Button
                            color="secondary"
                            variant="outlined"
                            onClick={() => handleIsEditingChange()}
                        >
                            {t(`common.${isEditing ? "save" : "edit"}`)}
                        </Button>
                    </ButtonGroup>
                </Grid>
            </Grid>)
    }
    const userRoleName = userRole != null ? userRole.displayName : null

    return (
        <Box>
            {
                loading ? <Loading /> :
                    <Box>
                        <HeaderBlock
                            title={userRoleName}
                            right={rightRender()}
                        />

                        {deleteDialog()}
                        {deleteUsersDialog()}
                        {addUsersToRoleDialog()}

                        <PageContainer>
                            {renderContent()}
                        </PageContainer>
                    </Box>
            }
        </Box>
    )
}

export default ViewUserRolesPage

